export const prefix = 'TrustedDevice';
export var Type;
(function (Type) {
    Type["Created"] = "Created";
    Type["Used"] = "Used";
})(Type || (Type = {}));
